import {
  GET_FAQS,
    SET_ALL_FAQS,
    CREATE_FAQS,
    UPDATE_FAQS,
} from "../../reducerTypes";

const initialState = {
  getData: {},
  getList: [],
};

const commentReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_FAQS:
      return {
        ...state,
        getList: action.payload,
      };
    case GET_FAQS:
      return {
        ...state,
        getData: action.payload,
      };
    case CREATE_FAQS:
      return {
        ...state,
        getData: action.payload,
      };
    case UPDATE_FAQS:
      return {
        ...state,
        getData: action.payload,
      };
    default:
      return state;
  }
};

export default commentReducer;
